import React from 'react';
import ModalV4 from "../../../../app/ui/modal/v4/v4";
import GitSelectRepository from "./select-repository/select-repository";
import GitSelectBranch from "./select-branch/select-branch-gitlab";
import ModalV4HeaderWhite from "../../../../app/ui/modal/v4/header-white/v4-header-white";
import GitSelectCommit from "./select-commit/select-commit";
import GDLoadingBlock from "../../../gd-components/loading/gd-loading-overlap/block/gd-loading-block";
import ErrorBoundary from "../../../error-boundary";
import ApiIntegrationGithub from "../../../gd/api/integrations/github";
import ApiIntegrationGitlab from "../../../gd/api/integrations/gitlab";
import GitSelectBranchGithub from "./select-branch/select-branch-github";

class ModalGit extends ModalV4 {

    constructor(props) {
        super(props);

        this.state = {
            mode: props.params.mode,
            curScreen: 'loading',
            selectedRepository: null,
            selectedBranch: null,
            branchId: null,
            repositories: null
        };


        let request;
        switch (props.params.gitProvider) {
            case 'github':
                request = ApiIntegrationGithub.getRepositories()
                break;
            case 'gitlab':
                request = ApiIntegrationGitlab.getRepositories()
                break;
        }

        request.done(response=>{

            this.setState({
                repositories: response,
                curScreen: 'select-repository'
            })
        })

    }

    goToScreen(curScreen) {
        this.setState({ curScreen: curScreen });
    }

    onSelectRepository = (repositoryId) => {

        const repository = _.find(this.state.repositories, repository=>{
            return repository.repositoryId === repositoryId;
        });

        this.setState({
            selectedRepository  : repository,
            curScreen           : 'select-branch'
        });
    };

    onSelectBranch = (branch) => {

        switch (this.state.mode) {

            case 'select-branch':

                let branchUrl;
                switch (this.props.params.gitProvider) {
                    case 'github':
                        // branchUrl = 'https://github.com' + this.state.selectedRepository.resourcePath + '/tree/' + branch.name; - old
                        branchUrl = branch.url          // new
                        break;
                    case 'gitlab':
                        branchUrl = branch.web_url;
                        break;
                }

                branch.url = branchUrl;

                this.props.params.callback(branch);
                gd.modal.hide();
                break;
            case 'select-commit':
                this.setState({
                    selectedBranch: branch,
                    curScreen: 'select-commit'
                });
                break;
        }
    };

    onSelectCommit = (commit) => {
        this.props.params.callback(commit);
        gd.modal.hide();
    };

    render() {
        let result = false;
        let title = "GIT";
        let onGoBack = null;

        switch (this.state.curScreen) {

            case "loading":
                result = <GDLoadingBlock />;
                title = "Select Repository";
                onGoBack = this.goToScreen.bind(this,'select-branch');
                break;

            case "select-commit":
                result = <GitSelectCommit branch={this.state.selectedBranch}
                                          gitProvider={this.props.params.gitProvider}
                                          repositoryId={this.state.selectedRepository.id}
                                          companyId={this.props.params.companyId}
                                          onSelectCommit={this.onSelectCommit}
                                          onClick={this.stopPropagation}/>;
                title = "Select Commit";
                onGoBack = this.goToScreen.bind(this,'select-branch');
                break;

            case "select-branch":

                switch (this.props.params.gitProvider) {
                    case 'github':
                        result = <GitSelectBranchGithub onSelectBranch={this.onSelectBranch} onClick={this.stopPropagation} repository={this.state.selectedRepository} />;
                        break;
                    case 'gitlab':
                        result = <GitSelectBranch onSelectBranch={this.onSelectBranch} onClick={this.stopPropagation} repository={this.state.selectedRepository} />;
                        break;
                }



                title = "Select Branch";
                onGoBack = this.goToScreen.bind(this,'select-repository');
                break;

            case "select-repository":
            default:
                result = <GitSelectRepository onSelectRepository={this.onSelectRepository} onClick={this.stopPropagation} repositories={this.state.repositories} />;
                title = "Select Repository";


        }


        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>
                <ErrorBoundary>
                <ModalV4HeaderWhite height={60} title={title} onGoBack={onGoBack} />
                {result}
                </ErrorBoundary>
            </div>
        );

    }
}

module.exports = ModalGit;
